export class ExteriorDeficiencyLayout {
	public fields = [
		{ fieldName: 'deficiencyName', label: 'Name' },
		{ fieldName: 'deficiencyType', label: 'Type' },
		{ fieldName: 'exteriorDeficiencySeverity', label: 'Severity' },
		{ fieldName: 'descriptionExteriorDeficiency', label: 'Description' },
		{ fieldName: 'deficiencyRemediationType', label: 'Remediation Type' }
	];
}
